<template>
    <div class="intel-hero">
        <div class="container">
            <div class="intel-hero__logo">
                <img src="/images/intel-gamer-days/gamer-day-logo.png" alt="Intel gamer day logo">
            </div>
            <h1 class="intel-hero__heading">
                Free game bundles
            </h1>
            <div class="row">
                <div class="col-md-6">
                    <div class="intel-hero__image">
                        <img src="/images/intel-gamer-days/bundle1.png" alt="i5 bundle">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="intel-hero__build">
                        <h3 class="intel-hero__build__heading">
                            WITH PURCHASE OF ANY INTEL CORE i5 BUILD
                        </h3>
                        <p class="intel-hero__build__description">
                            Total War: Three Kingdoms, Dungeons II, Guns of Icarus Alliance, $15 coaching credit at Gamer Sensei
                        </p>
                        <div class="intel-hero__build__buttons">
                            <a
                                href="#"
                                class="btn intel-hero__build__button"
                                @click.prevent="$emit('customize-build', builds[0].bld_number)"
                            >
                                Shop i5 build
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="intel-hero__separator col-md-6">
                    <img src="/images/intel-gamer-days/or.png" alt="Separator">
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="intel-hero__image padding-top">
                        <img src="/images/intel-gamer-days/bundle2.png" alt="i7 or i9 bundle">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="intel-hero__build">
                        <h3 class="intel-hero__build__heading">
                            WITH PURCHASE OF ANY INTEL CORE i7 OR i9 BUILD
                        </h3>
                        <p class="intel-hero__build__description">
                            Total War: Three Kingdoms, HitMan 2, PUBG, Halo Wars II, Paladins - Founder’s Pack, $15 coaching credit at Gamer Sensei
                        </p>
                        <div class="intel-hero__build__buttons">
                            <a
                                href="#"
                                class="btn intel-hero__build__button margin-right"
                                @click.prevent="$emit('customize-build', builds[1].bld_number)"
                            >
                                Shop i7 build
                            </a>
                            <a
                                href="#"
                                class="btn intel-hero__build__button"
                                @click.prevent="$emit('customize-build', builds[2].bld_number)"
                            >
                                Shop i9 build
                            </a>
                        </div>
                        <div class="intel-hero__date">
                            <h4 class="intel-hero__date__heading">
                                Offer valid through 9/30/19 while supplies last.
                            </h4>
                            <p class="intel-hero__date__description">
                                Game codes will be delivered by email.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IntelPromoHero",
    props: {
        builds: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.intel-hero {
    background-image: url("/images/intel-gamer-days/intel-hero-background.jpg");
    margin: 0 -15px;
    color: #FFFFFF;
    padding-top: 40px;
    background-size: cover;

    &__logo {
        text-align: center;

        img {
            width: 90px;
        }
    }

    &__heading {
        color: #FFFFFF;
        font-size: 48px;
        line-height: 52px;
        text-transform: uppercase;
        margin-bottom: 50px;
        text-align: center;

        @media (max-width: 991px) {
            margin-bottom: 30px;
        }

        @media (max-width: 768px) {
            font-size: 36px;
            line-height: 38px;
            margin-bottom: 40px;
        }
    }

    &__image {
        display: flex;
        justify-content: center;

        img {
            max-width: 370px;
            width: 100%;
        }
    }

    .padding-top {
        padding-top: 40px;

        @media (max-width: 991px) {
            padding-top: 20px;
        }
    }

    .margin-right {
        @media (max-width: 991px) {
            margin-right: 15px;
        }
    }

    &__build {
        @media (max-width: 991px) {
            text-align: center;
            max-width: 550px;
            margin: 0 auto 40px;
        }

        @media (max-width: 768px) {
            text-align: left;
            margin: 0 auto 30px;
        }

        &__heading {
            margin: 0 0 5px;
            text-transform: uppercase;

            @media (max-width: 768px) {
                font-size: 22px;
                margin: 5px 0;
            }
        }

        &__description {
            margin-bottom: 25px;
        }

        &__buttons {
            display: flex;
        }

        &__button {
            border-radius: 5px;
            background-color: #51007A;
            color: #FFFFFF;
            margin-right: 15px;

            @media (max-width: 1200px) {
                padding: 16px 30px;
            }

            @media (max-width: 991px) {
                width: 100%;
                margin: 0;
            }

            @media (max-width: 768px) {
                padding: 16px 25px;
            }

            &:hover {
                color: #51007A;
                background-color: #FFFFFF;
            }

        }
    }

    &__date {
        margin: 40px 0 70px;

        @media (max-width: 768px) {
            text-align: center;
        }

        @media (max-width: 991px) {
            margin: 30px 0 0;
        }

        &__heading {
            font-size: 20px;
            margin: 0 0 5px;

            @media (max-width: 768px) {
                font-size: 15px;
            }
        }
    }

    hr {
        border-top: 1px solid #8D29A0;
        margin: 0;
    }

    &__raffle {
        font-size: 20px;
        letter-spacing: 1.3px;
        line-height: 22px;
        display: flex;
        padding: 50px 70px;
        align-items: center;

        @media (min-width: 991px) and (max-width: 1200px) {
            padding: 30px 60px;
        }

        @media (max-width: 991px) {
            padding: 30px 10px;
            max-width: 550px;
            margin: 0 auto;
        }

        @media (max-width: 768px) {
            padding: 10px 0 30px;
            display: block;
        }

        &__text {
            font-size: 20px;
            letter-spacing: 1.3px;
            line-height: 22px;

            @media (max-width: 768px) {
                margin-bottom: 30px;
            }
        }

        &__button {
            border: 2px solid #FFFFFF;
            background-color: transparent;
            margin-left: 30px;

            @media (max-width: 768px) {
                width: 100%;
                margin: 0;
            }


            &:hover {
                background-color: #FFFFFF;

            }
        }
    }

    &__separator {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        img {
            @media (max-width: 480px) {
                width: 100%;
            }
        }
    }
}
</style>
